module.exports = __webpack_public_path__ + "img/pr-6.2e197e6c.png";